<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout v-show="this.$route.matched.length==2">
      <div class="main-page-content">
        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              icon="el-icon-download" 
              @click="downloadButton()"
              class="export-btn">
              导出客户数据
            </el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="客户名称">
              <el-input 
                v-model="searchCondition.username" 
                placeholder="输入客户名称" 
                clearable
                prefix-icon="el-icon-user">
              </el-input>
            </el-form-item>
            <el-form-item label="客户邮箱">
              <el-input 
                v-model="searchCondition.email" 
                placeholder="输入客户邮箱" 
                clearable
                prefix-icon="el-icon-message">
              </el-input>
            </el-form-item>
            <el-form-item label="客户电话">
              <el-input 
                v-model="searchCondition.mobile" 
                placeholder="输入客户电话" 
                clearable
                prefix-icon="el-icon-phone">
              </el-input>
            </el-form-item>
            <el-form-item label="客户公司">
              <el-input 
                v-model="searchCondition.company" 
                placeholder="输入客户公司" 
                clearable
                prefix-icon="el-icon-office-building">
              </el-input>
            </el-form-item>
            <el-form-item label="客户国家">
              <el-input 
                v-model="searchCondition.country" 
                placeholder="输入客户国家" 
                clearable
                prefix-icon="el-icon-location">
              </el-input>
            </el-form-item>
            <el-form-item label="客户行业">
              <el-input 
                v-model="searchCondition.industry" 
                placeholder="输入客户行业" 
                clearable
                prefix-icon="el-icon-suitcase">
              </el-input>
            </el-form-item>
            <el-form-item label="客户状态">
              <el-select v-model="searchCondition.customer_status" placeholder="请选择客户状态" clearable>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="userList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column
              width="80"
              label="序号">
              <template slot-scope="scope">
                <span class="row-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              label="头像">
              <template slot-scope="scope">
                <div class="avatar-container">
                  <img :src="scope.row.avatar" class="customer-avatar">
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="客户信息"
              min-width="260">
              <template slot-scope="scope">
                <div class="customer-info">
                  <p class="customer-name">
                    <i class="el-icon-user"></i>
                    <strong>{{scope.row.username}}</strong>
                  </p>
                  <p><i class="el-icon-message"></i> {{scope.row.email}}</p>
                  <p><i class="el-icon-phone"></i> {{scope.row.mobile}}</p>
                  <p><i class="el-icon-s-custom"></i> 分组：{{ scope.row.customer_group_names || '-' }}</p>
                  <p><i class="el-icon-time"></i> 注册：{{scope.row.created_at || '-'}}</p>
                  <p><i class="el-icon-position"></i> 注册IP：{{scope.row.register_ip || '-'}}</p>
                  <p><i class="el-icon-map-location"></i> 登录国家：{{ loginCountryText(scope.row) }}</p>
                  <p><i class="el-icon-time"></i> 最后登录：{{ formatLoginAt(scope.row.login_at) }}</p>
                  <p><i class="el-icon-data-line"></i> 累计登录：{{ Number(scope.row.login_count || 0) }} 次</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="公司信息">
              <template slot-scope="scope">
                <div class="company-info">
                  <p><i class="el-icon-office-building"></i> {{scope.row.company || '-'}}</p>
                  <p><i class="el-icon-location"></i> {{scope.row.country || '-'}}</p>
                  <p><i class="el-icon-suitcase"></i> {{scope.row.industry || '-'}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="状态">
              <template slot-scope="scope">
                <div class="status-info">
                  <div class="status-item">
                    <span class="status-label">启用/禁用：</span>
                    <el-switch 
                      v-model="scope.row.customer_status" 
                      :active-value="'1'"
                      :inactive-value="'0'"
                      active-color="#13ce66"
                      inactive-color="#ff4949" 
                      @change="changeStatus(scope.row)">
                    </el-switch>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="buttonType=='icon'"
              width="200"
              label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="编辑" placement="top">
                  <el-button 
                    size="mini" 
                    icon="el-icon-edit" 
                    @click="editButton(scope.row.id)"
                    class="action-btn edit-btn">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="收货地址" placement="top">
                  <el-button 
                    size="mini" 
                    icon="el-icon-map-location" 
                    @click="getAddress(scope.row.id)"
                    class="action-btn address-btn">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="订单" placement="top">
                  <el-button 
                    size="mini" 
                    icon="el-icon-s-order" 
                    @click="getOrder(scope.row.id)"
                    class="action-btn order-btn">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="文件" placement="top">
                  <el-button
                    size="mini"
                    icon="el-icon-files"
                    @click="getFile(scope.row.id)"
                    class="action-btn file-btn">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="补充信息" placement="top">
                  <el-button
                    size="mini"
                    icon="el-icon-tickets"
                    @click="getSurvey(scope.row.id)"
                    class="action-btn survey-btn">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="登录设备（需求6：查看/踢下线）" placement="top">
                  <el-button
                    size="mini"
                    icon="el-icon-monitor"
                    @click="openDevices(scope.row)"
                    class="action-btn device-btn">
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户名称" prop="username">
                <el-input v-model="formData.username"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户姓氏" prop="last_name">
                <el-input v-model="formData.last_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户邮箱" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户公司" prop="company">
                <el-input v-model="formData.company"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户国家" prop="country">
                <el-input v-model="formData.country"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户行业" prop="industry">
                <el-input v-model="formData.industry"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户电话" prop="mobile">
                <el-input v-model="formData.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户状态" prop="customer_status">
                <el-switch
                  v-model="formData.customer_status"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  active-text="启用"
                  inactive-text="禁用"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="注册时间">
                <el-input :value="formData.created_at || '-'" disabled></el-input>
              </el-form-item>
              <el-form-item label="注册IP">
                <el-input :value="formData.register_ip || '-'" disabled></el-input>
              </el-form-item>
              <el-form-item label="登录国家">
                <el-input :value="loginCountryText(formData)" disabled></el-input>
                <div class="login-country-tip">
                  服务端判定：确定＝Cloudflare 边缘判定，待确定＝仅语言等弱信号；判定时间 {{ formData.login_country_at || '-' }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="客户密码" prop="password">
                <el-input v-model="formData.password" type="password" placeholder="留空则不修改密码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>
    <ApeDrawer :drawerData="addressDrawerData"  @drawerClose="addressDrawerClose" @drawerConfirm="addressDrawerClose">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-table-column
                slot="second-column"
                label="用户邮箱">
                <template slot-scope="scope">
                  <span>{{scope.row.username}} </span>
                </template>
              </el-table-column>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <span>{{formData.username}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <span>{{formData.username}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <span>{{formData.username}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <span>{{formData.username}}</span>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </ApeDrawer>
    <!-- 补充信息（调查表单）弹窗 -->
    <el-dialog :visible.sync="surveyVisible" title="客户补充信息" width="660px">
      <div v-loading="surveyLoading" style="min-height: 120px;">
        <template v-if="surveyData && surveyData.id">
          <el-descriptions :column="2" border size="medium">
            <el-descriptions-item label="身份类型">{{ surveyIdentityMap[surveyData.identity_type] || surveyData.identity_type || '-' }}</el-descriptions-item>
            <el-descriptions-item label="访问原因">{{ surveyVisitReasonMap[surveyData.visit_reason] || surveyData.visit_reason || '-' }}</el-descriptions-item>
            <el-descriptions-item label="3D建模水平">{{ surveyKnowledgeMap[surveyData.knowledge_level] || surveyData.knowledge_level || '-' }}</el-descriptions-item>
            <el-descriptions-item label="电话">{{ surveyData.telephone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="提交语言">{{ surveyData.language || '-' }}</el-descriptions-item>
            <el-descriptions-item v-if="surveyData.identity_type === '2'" label="行业" :span="2">{{ surveyData.industry || '-' }}<span v-if="surveyData.industry_other">（{{ surveyData.industry_other }}）</span></el-descriptions-item>
            <template v-if="surveyData.identity_type === '3'">
              <el-descriptions-item label="学术角色">{{ surveyAcademicRoleMap[surveyData.academic_role] || surveyData.academic_role || '-' }}</el-descriptions-item>
              <el-descriptions-item label="研究领域">{{ surveyStudyFieldMap[surveyData.study_field] || surveyData.study_field || '-' }}</el-descriptions-item>
            </template>
            <el-descriptions-item label="提交时间" :span="2">{{ surveyData.created_at || '-' }}</el-descriptions-item>
          </el-descriptions>
          <el-divider content-position="left">提交环境</el-divider>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="IP">{{ surveyData.client_ip || '-' }}</el-descriptions-item>
            <el-descriptions-item label="浏览器">{{ surveyData.browser || '-' }}</el-descriptions-item>
            <el-descriptions-item label="操作系统">{{ surveyData.os || '-' }}</el-descriptions-item>
            <el-descriptions-item label="设备">{{ surveyData.device || '-' }}</el-descriptions-item>
            <el-descriptions-item label="提交页面" :span="2">{{ surveyData.page_url || '-' }}</el-descriptions-item>
            <el-descriptions-item label="来源" :span="2">{{ surveyData.referer || '-' }}</el-descriptions-item>
          </el-descriptions>
        </template>
        <div v-else style="text-align:center;color:#909399;padding:24px 0;">该客户暂未提交补充信息</div>
      </div>
      <div slot="footer">
        <el-button @click="surveyVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 需求6：登录设备管理弹窗（查看在线设备 / 手动踢下线） -->
    <el-dialog :visible.sync="devices.visible" :title="'登录设备 - ' + (devices.customerName || '')" width="720px">
      <div v-loading="devices.loading" style="min-height: 120px;">
        <div style="margin-bottom: 10px;">
          <span>有效设备：<b style="color:#67C23A">{{ devices.activeCount }}</b> 台</span>
          <el-button v-if="devices.activeCount > 0" size="mini" type="danger" style="margin-left: 16px;"
                     :loading="devices.revokingAll" @click="revokeAllDevices">全部踢下线</el-button>
        </div>
        <el-table :data="devices.list" size="mini" border>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.revoked === '1'" type="info" size="mini">已吊销</el-tag>
              <el-tag v-else-if="scope.row.online" type="success" size="mini">在线</el-tag>
              <el-tag v-else type="warning" size="mini">离线</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="device_ua" label="设备（User-Agent 摘要）" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="device_ip" label="签发IP" width="120"></el-table-column>
          <el-table-column prop="last_used_at" label="最近使用" width="150"></el-table-column>
          <el-table-column prop="expires_at" label="过期时间" width="150"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button v-if="scope.row.revoked !== '1'" size="mini" type="danger" plain
                         @click="revokeDevice(scope.row)">踢下线</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="devices.visible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import * as XLSX from 'xlsx';
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      searchCondition:{
        current_page: 1,
        query: "",
        params: [],
        order_by: 'created_at DESC',
        username:'',
        email:'',
        mobile:'',
        customer_status:'',
        country:'',
        industry:'',
        company:''
      },
      loadingStaus: true,
      uploadFileList:[],
      // 表格列表数据
      userList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        avatar:''
      },
      // 表单验证
      rules: {
        username: [{required: true,message:'名', trigger: 'blur' }],
        last_name: [{required: true,message:'姓', trigger: 'blur' }],
        mobile: [{required: false,message:'手机号', trigger: 'blur' }],
        email: [{required: true,message:'邮箱', trigger: 'blur' }],
        password: [{required: false,message:'密码', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      addressDrawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '580px',
      },
      rolesList: [],
      userRoles: [],
      // 补充信息（调查表单）弹窗
      surveyVisible: false,
      surveyLoading: false,
      surveyData: {},
      surveyIdentityMap: { '1': '个人 Individual', '2': '商业 Business', '3': '学术 Academic' },
      surveyVisitReasonMap: { '1': '个人项目', '2': '商业/学校项目/创业', '3': '兴趣学习' },
      surveyKnowledgeMap: { '1': '新手 Novice', '2': '高级初学者 Advanced Beginner', '3': '熟练 Competent', '4': '专家 Expert' },
      surveyAcademicRoleMap: { '1': '学生 Student', '2': '教授 Professor', '3': '研究员 Researcher', '4': '教师 Teacher', '5': '其他 Other' },
      surveyStudyFieldMap: { '1': '建筑 Architecture', '2': '艺术与设计 Art & Design', '3': '生物医学 Biomedical', '4': '工程 Engineering', '5': '其他 Others' },
      // 需求6：登录设备管理
      devices: {
        visible: false,
        loading: false,
        customerID: '',
        customerName: '',
        activeCount: 0,
        revokingAll: false,
        list: []
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    formatLoginAt(v) {
      if (v == null || v === '' || v === '0001-01-01 00:00:00' || String(v).indexOf('0001-01-01') === 0) {
        return '-'
      }
      return v
    },
    // 登录国家＝服务端判定结果（与客户自填的「客户国家」是两回事）：
    // confirmed 为 Cloudflare 边缘判定，pending 表示只有语言等弱信号，需人工判断。
    loginCountryText(row) {
      if (!row) return '-'
      const code = (row.login_country || '').toString().toUpperCase()
      const status = (row.login_country_status || '').toString()
      if (code && status === 'confirmed') return code + '（确定）'
      if (code) return '待确定 ' + code
      if (status === 'pending') return '待确定'
      return '-'
    },
    // 搜索
    searchButton() {
      this.list()
    },
    setSearchCondition() {
      this.searchCondition.query= ''
      this.searchCondition.params = []
      this.setValue('instr(username,?)',this.searchCondition.username)
      this.setValue('email=?',this.searchCondition.email)
      this.setValue('mobile=?',this.searchCondition.mobile)
      this.setValue('company=?',this.searchCondition.company)
      this.setValue('country=?',this.searchCondition.country)
      this.setValue('industry=?',this.searchCondition.industry)
      this.setValue('customer_status=?',this.searchCondition.customer_status)
    },
    setValue(operator,value) {
      if (value === '' || value === null || value === undefined) {
        return
      }
      if (this.searchCondition.query == ''){
        this.searchCondition.query = operator
      }else{
        this.searchCondition.query += ' and '+operator
      }
      this.searchCondition.params.push(value)
    },
    // 切换页码操作
    async switchPaging() {
      this.list()
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加客户'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.uploadFileList=[]
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑用户(UID：'+id+')'
      this.drawerData.loading = true
      try {
        let {info} = await this.$api.getCustomer(id)
        this.formData = info || {}
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '加载客户失败')
      }
      this.drawerData.loading = false
    },
    async getAddress(id) {
      window.open('/customer/'+id+'/address', '_blank');
    },
    async getOrder(id) {
       window.open('/customer/'+id+'/order', '_blank');
    },
    async getFile(id) {
       window.open('/customer/'+id+'/file', '_blank');
    },
    // 查看客户补充信息（调查表单，一人一份）
    async getSurvey(id) {
      this.surveyVisible = true
      this.surveyLoading = true
      this.surveyData = {}
      try {
        let res = await this.$api.post('/service/ola_app_customer_survey/list', {
          current_page: 1,
          page_size: 1,
          query: 'customer_id=?',
          params: [id]
        })
        let list = (res && res.data && res.data.list) ? res.data.list : []
        this.surveyData = list[0] || {}
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '加载补充信息失败')
      }
      this.surveyLoading = false
    },
    async changeStatus(row) {
      let res = await this.$api.post('/service/ola_app_customer/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
      }else{
        this.$message.error(res.message)
      }
    },
    // ===== 需求6：登录设备查看 / 踢下线 =====
    async openDevices (row) {
      const d = this.devices
      d.visible = true
      d.customerID = row.id
      d.customerName = row.user_name || row.email || ''
      await this.loadDevices()
    },
    async loadDevices () {
      const d = this.devices
      d.loading = true
      try {
        const res = await this.$api.post('/service/customer/devices', { customer_id: d.customerID })
        if (this.$apiSuccess(res)) {
          const data = res.data || {}
          // GinResp 会把 result_list 映射为响应键 list（func_resp.go）
          d.list = data.list || []
          d.activeCount = Number(data.active_count || 0)
        } else {
          this.$message.error(res.message || '加载设备失败')
        }
      } catch (e) {
        this.$message.error((e && e.message) ? e.message : '加载设备失败')
      }
      d.loading = false
    },
    async revokeDevice (row) {
      try {
        await this.$confirm('确定将该设备踢下线？该设备的 30 天自动登录立即失效。', '踢下线', { type: 'warning' })
      } catch (e) {
        return
      }
      const res = await this.$api.post('/service/customer/device_revoke', { id: row.id })
      if (this.$apiSuccess(res)) {
        this.$message.success('已踢下线')
        await this.loadDevices()
      } else {
        this.$message.error(res.message || '操作失败')
      }
    },
    async revokeAllDevices () {
      try {
        await this.$confirm('确定将该客户全部设备踢下线？所有 30 天自动登录立即失效。', '全部踢下线', { type: 'warning' })
      } catch (e) {
        return
      }
      const d = this.devices
      d.revokingAll = true
      try {
        const res = await this.$api.post('/service/customer/device_revoke_all', { customer_id: d.customerID })
        if (this.$apiSuccess(res)) {
          this.$message.success('已全部踢下线')
          await this.loadDevices()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } finally {
        d.revokingAll = false
      }
    },
    // 处理抽屉关闭
    addressDrawerClose() {
      this.initFormData()
      this.addressDrawerData.visible = false
      this.addressDrawerData.loading = true
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id 
      delete this.formData.CreatedAt
      delete this.formData.UpdatedAt
      delete this.formData.created_at
      delete this.formData.updated_at
      delete this.formData.login_at
      delete this.formData.register_ip
      if (!this.formData.password) {
        delete this.formData.password
      }
      if (this.formData.id==null || this.formData.id==0 || this.formData.id===''){
          if (!this.formData.customer_status) {
            this.formData.customer_status = '1'
          }
          id = await this.$api.addCustomer(this.formData)
      }else{
          id = await this.$api.modifyCustomer(this.formData)
      }
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      const target = { ...row }; // 复制所有字段
      delete target.Items; // 删除不用的
      delete target.login_at; // 删除不用的
      delete target.visible; // 删除不用的
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id = await this.$api.modifyCustomer(target)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.list()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteCustomer(id)
      if (info==null) {
        this.$nextTick(async () => {
          this.list()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_role:{system_role_id:0}}
        this.$refs['userForm'].resetFields()
      })
    },

    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.staff_image = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.staff_image = 0
      this.uploadFileList = fileList
    },
    // 初始化用户列表
    async list() {
      this.loadingStaus=true
      this.setSearchCondition()
      Object.assign(this.searchCondition,this.$refs['apeTable'].getPagingInfo())
      let res= await this.$api.post('/service/ola_app_customer/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        const rows = res.data.list || []
        this.userList = rows.map((row) => ({
          ...row,
          customer_status: row.customer_status != null && row.customer_status !== '' ? String(row.customer_status) : '0'
        }))
        this.pagingData.total = res.data.page.total
      }
      this.loadingStaus=false
    },
    async downloadButton() {
      let searchCondition = this.searchCondition
      delete searchCondition.page_size
      delete searchCondition.current_page
      let res = await this.$api.post('/service/ola_app_customer/list',searchCondition)
      if (this.$apiSuccess(res)){
        let workbook = XLSX.utils.book_new();
        const filteredData = res.data.list.map(item => ({
          "客户名称": item.username,
          "客户邮箱": item.email,
          "客户电话": item.mobile,
          "客户公司": item.company,
          "客户国家": item.country,
          "客户行业": item.industry,
          "所在分组": item.customer_group_names || '-',
          "客户状态": item.customer_status=='1'?'启用':'禁用',
          "注册时间": item.created_at,
          "注册IP": item.register_ip || '-',
          "登录国家": this.loginCountryText(item),
          "最后登录时间": this.formatLoginAt(item.login_at),
          "累计登录次数": Number(item.login_count || 0)
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ['客户名称', '客户邮箱', '客户电话', '客户公司', '客户国家', '客户行业', '所在分组', '客户状态', '注册时间', '注册IP', '登录国家', '最后登录时间', '累计登录次数']
        });
        XLSX.utils.book_append_sheet(workbook, worksheet, '客户列表');
        XLSX.writeFile(workbook, '客户列表.xlsx');
        this.$message.success('导出成功!')
      }else{
        this.$message.error(res.message)
      }
    }
  },
  mounted() {
    this.list()
  },
}
</script>

<style lang="stylus" scoped>
  // 登录国家判定说明（服务端判定，运营核对用）
  .login-country-tip
    margin-top 4px
    font-size 12px
    line-height 1.4
    color #909399

  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 操作面板
  .action-card
    background white
    border-radius 12px
    padding 20px 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .action-buttons
    display flex
    gap 12px
    align-items center

  .export-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 10px 20px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px
      
    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease
      
      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

    /deep/ .el-select
      width 180px

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 12px 24px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  // 序号样式
  .row-number
    font-weight 600
    color #667eea
    background #f0f4ff
    padding 4px 8px
    border-radius 4px
    font-size 12px

  // 头像容器
  .avatar-container
    display flex
    justify-content center
    
  .customer-avatar
    width 64px
    height 64px
    border-radius 50%
    object-fit cover
    border 3px solid #e5e7eb
    transition all 0.3s ease
    
    &:hover
      border-color #667eea
      transform scale(1.05)

  // 客户信息
  .customer-info
    .customer-name
      margin 4px 0
      display flex
      align-items center
      gap 8px
      
      i
        color #667eea
        font-size 16px
      
      strong
        color #1f2937
        font-size 14px
    
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      display flex
      align-items center
      gap 6px
      
      i
        color #6b7280
        width 14px

  // 公司信息
  .company-info
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      display flex
      align-items center
      gap 6px
      
      i
        color #6b7280
        width 14px

  // 状态信息
  .status-info
    .status-item
      margin 8px 0
      display flex
      align-items center
      gap 8px
      
      .status-label
        font-size 12px
        color #374151
        font-weight 500
        min-width 70px

  // 操作按钮
  .action-btn
    margin-left 6px
    border-radius 6px
    padding 6px
    transition all 0.3s ease
    
    &:hover
      transform translateY(-1px)
    
    &.edit-btn
      background linear-gradient(45deg, #fbbf24, #f59e0b)
      border none
      color white
      
      &:hover
        box-shadow 0 4px 15px rgba(251, 191, 36, 0.4)
    
    &.address-btn
      background linear-gradient(45deg, #10b981, #059669)
      border none
      color white
      
      &:hover
        box-shadow 0 4px 15px rgba(16, 185, 129, 0.4)
    
    &.order-btn
      background linear-gradient(45deg, #3b82f6, #2563eb)
      border none
      color white
      
      &:hover
        box-shadow 0 4px 15px rgba(59, 130, 246, 0.4)
    
    &.file-btn
      background linear-gradient(45deg, #8b5cf6, #7c3aed)
      border none
      color white
      
      &:hover
        box-shadow 0 4px 15px rgba(139, 92, 246, 0.4)

    &.device-btn
      background linear-gradient(45deg, #14b8a6, #0d9488)
      border none
      color white

      &:hover
        box-shadow 0 4px 15px rgba(20, 184, 166, 0.4)

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
      font-size 24px
      
    .action-card, .search-card, .table-card
      padding 16px
      
    .customer-info, .company-info
      p, .customer-name
        font-size 12px
        
    .status-info
      .status-item
        flex-direction column
        align-items flex-start
        gap 4px
</style>
